import { Flex } from "@aws-amplify/ui-react"
import React from "react"
import styled from "styled-components"
import { Link } from "@engaging-tech/routing"
import ProfileHeader from "./ProfileHeader"

const StyledLogo = styled.img`
  width: 145px;
  height: 34px;
  margin: 5px;
`
const NewNav = ({ signOut, user }) => {
  return (
    <Flex
      direction="row"
      alignItems="center"
      wrap="nowrap"
      gap="1rem"
      justifyContent="space-between"
    >
      <Flex>
        <Link to="/">
          <StyledLogo
            src="https://engaging-works.s3.eu-west-2.amazonaws.com/production/media/companylogos/WorkL_Logo_TEAL.png"
            alt="WorkL logo in teal"
          />{" "}
        </Link>
      </Flex>
      <Flex justifyContent="flex-end">
        <ProfileHeader signOut={signOut} user={user} />
      </Flex>
    </Flex>
  )
}

export default NewNav
